/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantInvestmentObjectiveDto } from '../models/PagedResultDto_ParticipantInvestmentObjectiveDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_CreateUpdateParticipantInvestmentObjectiveDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_CreateUpdateParticipantInvestmentObjectiveDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantInvestmentObjectiveService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantInvestmentObjectiveParticipantInvestmentObjectivesList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-investment-objective/participant-investment-objectives-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantInvestmentObjective(
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_CreateUpdateParticipantInvestmentObjectiveDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-investment-objective',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ParticipantInvestmentObjectiveDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantInvestmentObjective(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ParticipantInvestmentObjectiveDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-investment-objective',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantInvestmentObjective(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_CreateUpdateParticipantInvestmentObjectiveDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-investment-objective/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantInvestmentObjective(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-investment-objective/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantInvestmentObjective1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantInvestmentObjective_ParticipantInvestmentObjectiveDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-investment-objective/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
